const dataSolution = [
    {
        id: 1,
        img: '/assets/cerv/home/img_capacitacionelearning_dark.png',
        title: "PLATAFORMAS DE E-LEARNING",
        desc: "Personalizamos plataformas para capacitar utilizando contenidos interactivos.",
        link: "/e-learning"
    },
    {
        id: 2,
        img: '/assets/cerv/home/img_simuladoresvirtuales_dark.png',
        title: "SIMULADORES",
        desc: "Simuladores avanzados para seguridad, mantenimiento y operaciones.",
        link: "/simulators"
    },
    {
        id: 3,
        img: '/assets/cerv/home/img_solucionesamedida_dark.png',
        title: "CAPACITACIONES",
        desc: "Capacitaciones personalizadas en seguridad, mantenimiento y operaciones.",
        link: "/training"
    },
    {
        id: 4,
        img: '/assets/cerv/home/HSE.png',
        title: "APP DE GESTION HSE",
        desc: "Desarrollamos soluciones móviles y digitales para gestionar procesos de seguridad.",
        link: "/hse-management"
    },
]

export default dataSolution;